export default {
  SHIFT: 'shift'
}
